import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getBranchToPerson = async ({ id, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.GET_BRANCH_ASSIGNED_TO_ID_PERSON}/${id}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default getBranchToPerson;